import React, {createContext} from "react";
import {useSearchParams} from "react-router-dom";

export type PaginationContextState = {
    currentPage?: number,
    onNextPage?: () => void,
    onPreviousPage?: () => void,
    onSelectPage?: (page: number) => void,
}

export const IPaginationContext = createContext<PaginationContextState>({})

const PaginationContext = (props: { children }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const handleNextPage = () => {
        const urlSearchParams = new URLSearchParams(searchParams)
        const currentPage = parseInt(urlSearchParams.get("page")) ?? 1
        urlSearchParams.set("page", (currentPage + 1).toString())
        setSearchParams(urlSearchParams)
    }

    const handlePreviousPage = () => {
        const urlSearchParams = new URLSearchParams(searchParams)
        const currentPage = parseInt(urlSearchParams.get("page")) ?? 1
        urlSearchParams.set("page", (currentPage - 1).toString())
        setSearchParams(urlSearchParams)
    }

    const handleSelectPage = (page: number) => {
        const urlSearchParams = new URLSearchParams(searchParams)
        urlSearchParams.set("page", page.toString())
        setSearchParams(urlSearchParams)
    }
    return <IPaginationContext.Provider
        value={{
            currentPage: parseInt(searchParams.get("page")) || 1,
            onNextPage: handleNextPage,
            onPreviousPage: handlePreviousPage,
            onSelectPage: handleSelectPage,
        }}>
        {props.children}
    </IPaginationContext.Provider>
}

export default PaginationContext